import {Injectable} from '@angular/core';
import {combineEpics} from 'redux-observable';
import {PollEpics} from './poll.epics';
import {ConfigEpics} from './config.epics';
import {QuestionEpics} from './question.epics';
import {ScriptQuestSetsEpics} from './scriptQuestSets.epics';

@Injectable()
export class RootEpic {

    constructor(private pollEpics: PollEpics,
                private configEpics: ConfigEpics,
                private questionEpics: QuestionEpics,
                private scriptQuestSetsEpics: ScriptQuestSetsEpics) {

    }

    epic() {
        return combineEpics(...[
            ...this.pollEpics.epics(),
            ...this.configEpics.epics(),
            ...this.questionEpics.epics(),
            ...this.scriptQuestSetsEpics.epics()
        ]);
    }

}
